import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper'
import Button from 'material-ui/Button'
import Paper from 'material-ui/Paper'
import Input, { InputLabel } from 'material-ui/Input'
import Radio, { RadioGroup } from 'material-ui/Radio'
import {
  FormLabel,
  FormControl,
  FormControlLabel,
  FormHelperText
} from 'material-ui/Form'

import { saveStep, savePopCount } from './actions'

class Question1 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: '',
      showPopulation: false,
      popCount: 'Loading...',
      popLoaded: false
    }
  }

  handleChange = (event, value) => {
    this.setState({ value })
  }

  onShowPopulation = () => {
    this.getDistribution()
    this.setState({
      showPopulation: true
    })
  }

  onNext() {
    if (this.state.popLoaded) {
      this.props.saveStep()
      this.props.savePopCount(this.state.popCount)
      this.props.changeRoute(
        '/console/search/create_new_search/six_basic_filters/question2'
      )
    } else {
      alert('Please wait for the population count to load before')
    }
  }

  async getDistribution() {
    this.setState({
      popCount: 'Loading...',
      popLoaded: false
    })

    let currentComponent = this
    // Get Population Count
    await axios({
      method: 'get',
      url: `https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/54/agelow/35/oarhigh/10/oarlow/7/herprefage/0/herprefans/0/clrhigh/4/clrlow/1/education/-1/income/-1/cust/${
        this.props.customer_number
      }`
    }).then(function(response) {
      if (response.data[0]['SearchCount']) {
        currentComponent.setState({
          popCount: response.data[0]['SearchCount'],
          popLoaded: true
        })
      } else {
        currentComponent.getDistribution()
      }
    })
  }

  render() {
    const { classes, theme, location } = this.props
    const { showPopulation } = this.state
    const label = 'Select distance you want'
    const content = 'What distance do you want from your zip code?'
    const defaultValue = 'Ex: 1310'

    if (showPopulation) {
      return (
        <div className={classes.root}>
          <Typography type="body2" color="inherit" className={classes.flex}>
            1. Distance
          </Typography>
          <br />
          <Typography>
            By default, the search is currently set to a 40 mile radius.
            Searching other distances is currently not supported.
          </Typography>
          <br />
          <FormControl aria-describedby="name-helper-text">
            <InputLabel htmlFor="name-helper">Zip Code</InputLabel>
            <Input value={64139} id="zip-code-helper" />
            <FormHelperText id="name-helper-text">
              Type in your zip code above.
            </FormHelperText>
            <br />
            <br />
            <Typography>Distance from Zip Code</Typography>
            {/*this.state.value*/}
            <RadioGroup
              aria-label="distance"
              name="distance"
              value="40"
              onChange={this.handleChange}
              className={classes.group}
            >
              <FormControlLabel
                className={classes.radioButton}
                value="5"
                control={<Radio />}
                label="5 Miles"
              />
              <FormControlLabel
                className={classes.radioButton}
                value="10"
                control={<Radio />}
                label="10 Miles"
              />
              <FormControlLabel
                className={classes.radioButton}
                value="20"
                control={<Radio />}
                label="20 Miles"
              />
              <FormControlLabel
                className={classes.radioButton}
                value="30"
                control={<Radio />}
                label="30 Miles"
              />
              <FormControlLabel
                value="40"
                control={<Radio />}
                label="40 Miles"
              />
            </RadioGroup>
          </FormControl>
          <div className={classes.population}>
            <Typography type="body2">Profiles after filter applied:</Typography>
            <Typography>Population Count: {this.state.popCount}</Typography>
          </div>
          <div className={classes.buttonNext}>
            {!this.state.popLoaded && (
              <Button
                raised
                disabled
                onClick={() => this.onNext()}
                color="primary"
                align="center"
                className={classes.button}
              >
                Next
              </Button>
            )}
            {this.state.popLoaded && (
              <Button
                raised
                onClick={() => this.onNext()}
                color="primary"
                align="center"
                className={classes.button}
              >
                Next
              </Button>
            )}
          </div>
        </div>
      )
    } else {
      return (
        <div className={classes.root}>
          <Typography type="body2" color="inherit" className={classes.flex}>
            1. Distance
          </Typography>
          <br />
          <Typography>
            By default, the search is currently set to a 40 mile radius.
            Searching other distances is currently not supported.
          </Typography>
          <br />
          <FormControl aria-describedby="name-helper-text">
            <InputLabel htmlFor="name-helper">Zip Code</InputLabel>
            <Input value={64139} id="zip-code-helper" />
            <FormHelperText id="name-helper-text">
              Type in your zip code above.
            </FormHelperText>
            <br />
            <br />
            <Typography>Distance from Zip Code</Typography>
            {/*this.state.value*/}
            <RadioGroup
              aria-label="distance"
              name="distance"
              value="40"
              onChange={this.handleChange}
              className={classes.group}
            >
              <FormControlLabel
                className={classes.radioButton}
                value="5"
                control={<Radio />}
                label="5 Miles"
              />
              <FormControlLabel
                className={classes.radioButton}
                value="10"
                control={<Radio />}
                label="10 Miles"
              />
              <FormControlLabel
                className={classes.radioButton}
                value="20"
                control={<Radio />}
                label="20 Miles"
              />
              <FormControlLabel
                className={classes.radioButton}
                value="30"
                control={<Radio />}
                label="30 Miles"
              />
              <FormControlLabel
                value="40"
                control={<Radio />}
                label="40 Miles"
              />
            </RadioGroup>
          </FormControl>
          <div className={classes.buttonNext}>
            <Button
              raised
              onClick={() => this.onShowPopulation()}
              color="primary"
              align="center"
              className={classes.button}
            >
              Apply Filter
            </Button>
          </div>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    distance: state.distance
  }
}

function matchDispatchToProps(dispatch) {
  return {
    saveStep: bindActionCreators(saveStep, dispatch),
    savePopCount: bindActionCreators(savePopCount, dispatch),
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, matchDispatchToProps)(Question1)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/scenes/Question1/index.js